export const usersRes = (state) => state.users;
export const companiesRes = (state) => state.companies;
export const cryptosRes = (state) => state.cryptos;
export const tickersRes = (state) => state.tickers;
export const hashtagsRes = (state) => state.hashtags;
export const indicesRes = (state) => state.indices;
export const symbolsRes = (state) => state.symbols;
export const isSearchLoading = (state) => state.searchLoading;
export const allSuggestedIndices = (state) => state.allSuggestedIndices.data;
export const allSuggestedIndicesFetchDate = (state) =>
  state.allSuggestedIndices.fetchDate;
export const allSuggestedForex = (state) => state.allSuggestedForex.data;
export const allSuggestedStocks = (state) => state.allSuggestedStocks.data;
export const allSuggestedStocksFetchDate = (state) =>
  state.allSuggestedStocks.fetchDate;
export const v2Tickers = (state) => state.v2.tickers;
export const v2HasMoreCompanies = (state) => state.v2.hasMoreCompanies;
export const v2HasMoreEtfs = (state) => state.v2.hasMoreEtfs;
export const v2HasMoreCryptos = (state) => state.v2.hasMoreCryptos;
export const v2Users = (state) => state.v2.users;
export const v2HasMoreUsers = (state) => state.v2.hasMoreUsers;
export const v2Page = (state) => state.v2.page;
export const v2ResultsPerPage = (state) => state.v2.resultsPerPage;
